import { CashFlowData } from '../types';

// Sample cash flow data for March 2025
export const cashFlowData: CashFlowData[] = [
  { date: "2025-03-05", day: "Wednesday", balance: 0, gameOver: false },
  { date: "2025-03-06", day: "Thursday", balance: 0, gameOver: false },
  { date: "2025-03-07", day: "Friday", balance: 0, gameOver: false },
  { date: "2025-03-08", day: "Saturday", balance: 0, gameOver: false },
  { date: "2025-03-09", day: "Sunday", balance: 0, gameOver: false },
  { date: "2025-03-10", day: "Monday", balance: 0, gameOver: false },
  { date: "2025-03-11", day: "Tuesday", balance: 0, gameOver: false },
  { date: "2025-03-12", day: "Wednesday", balance: 0, gameOver: false },
  { date: "2025-03-13", day: "Thursday", balance: 0, gameOver: false },
  { date: "2025-03-14", day: "Friday", balance: 0, gameOver: false },
  { date: "2025-03-15", day: "Saturday", balance: 0, gameOver: false },
  { date: "2025-03-16", day: "Sunday", balance: 0, gameOver: false },
  { date: "2025-03-17", day: "Monday", balance: 0, gameOver: false },
  { date: "2025-03-18", day: "Tuesday", balance: 0, gameOver: false },
  { date: "2025-03-19", day: "Wednesday", balance: 0, gameOver: false },
  { date: "2025-03-20", day: "Thursday", balance: 0, gameOver: false },
  { date: "2025-03-21", day: "Friday", balance: 0, gameOver: false },
  { date: "2025-03-22", day: "Saturday", balance: 0, gameOver: false },
  { date: "2025-03-23", day: "Sunday", balance: 0, gameOver: false },
  { date: "2025-03-24", day: "Monday", balance: 0, gameOver: false },
  { date: "2025-03-25", day: "Tuesday", balance: 0, gameOver: false },
  { date: "2025-03-26", day: "Wednesday", balance: 0, gameOver: false },
  { date: "2025-03-27", day: "Thursday", balance: 0, gameOver: false },
  { date: "2025-03-28", day: "Friday", balance: 0, gameOver: false },
  { date: "2025-03-29", day: "Saturday", balance: 0, gameOver: false },
  { date: "2025-03-30", day: "Sunday", balance: 0, gameOver: false },
  { date: "2025-03-31", day: "Monday", balance: 0, gameOver: false }
];

export const cashFlowSettings = {
  account: "Operating",
  endDate: "2025-06-30",
  includeDiscretionary: false,
  totalMoneyOut: 0,
  gameOver: "Not Yet!"
};